import { Skeleton } from "@/atoms/skeleton";

/**
 * The wait, at the real geometry of the sheet (spec skeleton 1.4; sheet DS29).
 *
 * Every block below stands at the height of the thing it is standing in for: the 48 seller mark (square, since it may be a business's), the
 * 24 heading, the 56 figure, the three 40 included rows, the 48 wallet, six 48 fields, three
 * totals rows and the 48 button. That is the point of a skeleton and the reason the old page's
 * grey pills were worse than nothing: the content used to land at a different height and the
 * whole page jumped under the reader's eyes.
 *
 * Paper muted, never grey, and the wash is off under reduced motion.
 */

export function CheckoutSkeleton() {
  return (
    <div className="gap-gk-6 flex flex-col" aria-hidden="true">
      <div className="gap-gk-4 flex items-center">
        <Skeleton style={{ width: 48, height: 48 }} />
        <div className="gap-gk-2 flex flex-1 flex-col">
          <Skeleton style={{ width: 88, height: 13 }} />
          <Skeleton style={{ width: "60%", height: 24 }} />
        </div>
      </div>

      <div className="gap-gk-4 flex flex-col">
        <div className="gap-gk-4 flex items-start">
          <Skeleton style={{ width: 48, height: 48 }} />
          <Skeleton style={{ width: "55%", height: 24 }} />
        </div>
        <Skeleton style={{ width: 220, height: 56 }} />
        <div className="flex flex-col">
          {[0, 1, 2].map((row) => (
            <div key={row} className="flex min-h-[40px] items-center">
              <Skeleton style={{ width: `${70 - row * 8}%`, height: 14 }} />
            </div>
          ))}
        </div>
      </div>

      <Skeleton style={{ height: 52 }} />

      <div className="gap-gk-4 flex flex-col">
        {[0, 1, 2, 3, 4, 5].map((field) => (
          <div key={field} className="gap-gk-2 flex flex-col">
            <Skeleton style={{ width: 96, height: 13 }} />
            <Skeleton style={{ height: 52 }} />
          </div>
        ))}
      </div>

      <div className="gap-gk-3 flex flex-col">
        {[0, 1, 2].map((row) => (
          <div
            key={row}
            className="flex min-h-[40px] items-center justify-between"
          >
            <Skeleton style={{ width: "45%", height: 14 }} />
            <Skeleton style={{ width: 96, height: 14 }} />
          </div>
        ))}
      </div>

      <Skeleton style={{ height: 48 }} />
    </div>
  );
}
